export const HTTP_HEADER = {
  CSRF_TOKEN: 'anti-csrftoken-a2z', // Amazon's standard CSRF header for API requests
};
